import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export const ALTERAR_MOTORISTA = '@motoristaActions/ALTERAR_MOTORISTA'
export const CADASTRAR_MOTORISTA = '@motoristaActions/CADASTRAR_MOTORISTA'
export const BUSCAR_MOTORISTA = '@motoristaActions/BUSCAR_MOTORISTA'
export const EXCLUIR_MOTORISTA = '@motoristaActions/EXCLUIR_MOTORISTA'

export function cadastrarMotorista (motorista, codigoEmpresa) {
  return dispatch => axios.post(`${URL}/motorista/empresa/${codigoEmpresa}/cadastrar`, motorista, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_MOTORISTA,
        payload: response.data
      })
  )
}

export  function alterarMotorista (motorista, codigoEmpresa) {
  const url = `${URL}/motorista/empresa/${codigoEmpresa}/alterar`;
  return dispatch => axios.post(url, motorista, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_MOTORISTA,
        payload: response.data
      })
  )
}

export  function excluirMotorista (codigoEmpresa, codigoMotorista) {
    const url = `${URL}/motorista/${codigoMotorista}/empresa/${codigoEmpresa}/excluir`;
    return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: EXCLUIR_MOTORISTA,
            payload: response.data
        })
    )
}

export function buscarMotorista (idUsuarioEmpresa, codigoEmpresa) {
  const url = `${URL}/motorista/empresa/${codigoEmpresa}/usuario-empresa/${idUsuarioEmpresa}`
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_MOTORISTA,
        payload:response.data
      })
  )
}
